import { offset, shift, size, type Middleware, type Placement } from '@floating-ui/dom';

export const datePickerPopperClassName = 'autoscript-datepicker-popper';

export const datePickerPopperMinWidth = 280;

export const datePickerPopperPlacement: Placement = 'bottom-start';

const reactDatePickerBuiltInGap = 10;

const popperOffset = offset(-reactDatePickerBuiltInGap);

export const datePickerPopperModifiers: Middleware[] = [
  popperOffset,
  size({
    apply: ({ rects, elements }) => {
      elements.floating.style.width = `${Math.max(rects.reference.width, datePickerPopperMinWidth)}px`;
    },
  }),
];

export const dateRangePickerPopperModifiers: Middleware[] = [
  popperOffset,
  shift({ padding: 8 }),
  size({
    padding: 8,
    apply: ({ availableWidth, elements }) => {
      elements.floating.style.width = 'max-content';
      elements.floating.style.maxWidth = `${Math.max(availableWidth, datePickerPopperMinWidth)}px`;
    },
  }),
];
